export { default as VraySolidIcon } from './VraySolidIcon';
